import React from 'react';
import { ShieldCheckIcon, CheckCircle2Icon, LockIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { UrgencyTimer } from './UrgencyTimer';
import { PRODUCT_IMAGE, PRICE_NOW, PRICE_BEFORE, CHECKOUT_URL } from '../lib/constants';
const summaryItems = [{
  label: '14 Módulos paso a paso',
  value: 'Incluido'
}, {
  label: 'Banco de 65 preguntas comentadas',
  value: 'Incluido'
}, {
  label: 'Simulacro de examen interactivo',
  value: 'Incluido'
}, {
  label: '7 Bonos exclusivos',
  value: 'GRATIS hoy'
}, {
  label: 'Planillas, chuletas y formularios',
  value: 'Incluido'
}, {
  label: 'Acceso inmediato en PDF',
  value: 'Incluido'
}];
// Final offer: urgency, order summary, price and main CTA.
export function OfferSection() {
  return <section id="comprar" className="scroll-mt-4 px-5 py-10" data-id="element-105">
      <div className="mx-auto max-w-md" data-id="element-106">
        <UrgencyTimer data-id="element-107" />

        <div className="mt-5 overflow-hidden rounded-2xl border-2 border-[#c8a24a] bg-[#0b2545] shadow-2xl shadow-black/40" data-id="element-108">
          <div className="bg-[#c8a24a] px-4 py-2 text-center text-sm font-extrabold uppercase tracking-wide text-[#061a33]" data-id="element-109">
            Tu pedido de hoy
          </div>

          <div className="p-4" data-id="element-110">
            <div className="flex gap-3" data-id="element-111">
              <img src={PRODUCT_IMAGE} alt="Pack PER — Licencia de Navegación Sencilla" className="h-24 w-24 flex-none rounded-lg border border-[#c8a24a]/40 object-cover" data-id="element-112" />
              <div className="min-w-0" data-id="element-113">
                <h3 className="font-[Montserrat] text-base font-extrabold leading-snug text-white" data-id="element-114">
                  Pack PER — Licencia de Navegación Sencilla
                </h3>
                <p className="mt-1 text-xs text-blue-200" data-id="element-115">
                  14 módulos + 7 bonos · 100% PDF · Entrega inmediata
                </p>
              </div>
            </div>

            <ul className="mt-4 space-y-2" data-id="element-116">
              {summaryItems.map(item => <li key={item.label} className="flex items-center justify-between gap-2 border-b border-white/5 pb-2 text-sm" data-id="element-117">
                  <span className="flex items-center gap-2 text-blue-50" data-id="element-118">
                    <CheckCircle2Icon className="h-4 w-4 flex-none text-emerald-400" aria-hidden="true" data-id="element-119" />
                    {item.label}
                  </span>
                  <span className={`flex-none text-xs font-bold ${item.value.includes('GRATIS') ? 'text-emerald-400' : 'text-blue-200'}`} data-id="element-120">
                    {item.value}
                  </span>
                </li>)}
            </ul>

            <div className="mt-5 rounded-xl bg-[#061a33] p-4 text-center" data-id="element-121">
              <p className="text-sm text-blue-200" data-id="element-122">
                Precio normal{' '}
                <span className="font-bold text-slate-400 line-through" data-id="element-123">
                  {PRICE_BEFORE}€
                </span>
              </p>
              <div className="mt-1 flex items-end justify-center gap-1" data-id="element-124">
                <span className="font-[Montserrat] text-5xl font-extrabold leading-none text-[#e6c168]" data-id="element-125">
                  {PRICE_NOW}€
                </span>
              </div>
              <p className="mt-1 text-xs font-semibold uppercase tracking-wide text-emerald-400" data-id="element-126">
                Pago único · Ahorras {Number(PRICE_BEFORE) - Number(PRICE_NOW)}€
              </p>
            </div>

            <div className="mt-4" data-id="element-127">
              <CtaButton onClick={() => {
              window.location.href = CHECKOUT_URL;
            }} data-id="element-128" />
            </div>

            <div className="mt-3 flex flex-col items-center gap-1 text-center" data-id="element-129">
              <span className="flex items-center gap-1.5 text-xs text-blue-200" data-id="element-130">
                <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-131" /> Pago
                seguro y encriptado
              </span>
              <span className="flex items-center gap-1.5 text-xs text-blue-200" data-id="element-132">
                <ShieldCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-133" />{' '}
                Descarga inmediata tras la compra
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}